import classNames from 'classnames'
import * as React from 'react'

import SvgIcon from '../SvgIcon/SvgIcon'

import styles from './ClassicTabMammoth.css'

export default function ClassicTabMammoth({className}: {className?: string}) {
  return (
    <SvgIcon
      icon="mammoth-20px"
      title="Opens in Classic UI"
      className={classNames(styles.icon, className)}
    />
  )
}
